import React, { useState } from "react";
import "../css/returns.scss";

function Returns() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  const faqItems = [
    {
      id: "can-i-place-an-order-over-the-phone",
      question: "Can I place an order over the phone?",
      answer: (
        <p>
          While ordering through the Dilverbloom Online Marketplace, we
          understand if you would rather talk to a person when placing your
          order. We are happy to accept phone orders at (888) 260-2192.
        </p>
      ),
    },
    {
      id: "how-does-return-work-with-a-food-item",
      question: "How does return work with a food item?",
      answer: (
        <p>
          If you find any problems with your order, we certainly want to hear
          about it and see what we can do to help. Please give us a call at
          888-260-2192 or email us at build@dilverbloom.online We will do
          whatever is reasonable to resolve any situation and determine if a
          return is required.
        </p>
      ),
    },
    {
      id: "what-forms-of-payment-do-you-accept",
      question: "What forms of payment do you accept?",
      answer: (
        <>
          <p>We accept the following payment methods:</p>
          <p>
            American Express, Apple Pay, Discover, JCB, Mastercard, Paypal,
            Visa.
          </p>
          <p>
            Other payment methods may be accepted on a per case basis and must
            be discussed with a Dilverbloom representative at 1 (888) 260-2192.
          </p>
        </>
      ),
    },
  ];

  return (
    <section
      id="ordering-returns-section"
      className="faqs-section"
    >
      <div id="ordering-returns" className="faqs reveal come-in">
        <div className="faqs__outer js-main-toggle main-open">
          <div className="faqs__heading-wrap js-main-toggler">
            <h3 className="type__heading--three faqs__category-heading site-wrap-wide medium-cap reveal come-in">
              Ordering &amp; Returns
            </h3>
          </div>
          <div
            className="js-main-togglee faqs__inner"
            style={{ display: "block" }}
          >
            {faqItems.map((faq) => (
              <div
                key={faq.id}
                id={faq.id}
                className={`faq js-toggle ${openFaq === faq.id ? "open" : ""}`}
                onClick={() => toggleFaq(faq.id)}
              >
                <div className="faq__question js-toggler">{faq.question}</div>
                <div className="faq__answer wysiwyg wysiwyg__faq js-togglee">
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Returns;
